"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBalance = exports.getLedgerInfo = exports.Ledger = void 0;
const utils_1 = require("../../../utils");
exports.Ledger = {
    _namespace_: "ledger",
    async info() {
        const message = await this.call("ledger.info");
        return getLedgerInfo(message);
    },
    async balance(address, symbols) {
        const m = new Map([[1, symbols !== null && symbols !== void 0 ? symbols : []]]);
        address && m.set(0, address);
        const res = await this.call("ledger.balance", m);
        return getBalance(res);
    },
    async send(param, { nonce } = { nonce: (0, utils_1.makeRandomBytes)(16) }) {
        return await this.call("ledger.send", (0, utils_1.makeLedgerSendParam)(param), { nonce });
    },
};
function getLedgerInfo(message) {
    const result = { symbols: new Map() };
    const decodedContent = message.getPayload();
    if (decodedContent) {
        if (decodedContent.has(4)) {
            const symbols = decodedContent.get(4);
            for (const symbol of symbols) {
                const address = symbol[0].toString();
                const symbolName = symbol[1];
                result.symbols.set(address, symbolName);
            }
        }
    }
    return result;
}
exports.getLedgerInfo = getLedgerInfo;
function getBalance(message) {
    const result = { balances: new Map() };
    const messageContent = message.getPayload();
    if (messageContent && messageContent.has(0)) {
        const symbolsToBalancesMap = messageContent.get(0);
        if (!(symbolsToBalancesMap instanceof Map))
            return result;
        for (const balanceEntry of symbolsToBalancesMap) {
            const symbolAddress = balanceEntry[0].toString();
            const balance = balanceEntry[1];
            result.balances.set(symbolAddress, balance);
        }
    }
    return result;
}
exports.getBalance = getBalance;
